<!-- Patient Type Form | If Patient type is 1=Registered, 2=New -->
<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
        <iq-card>

            <!-- Header -->
            <template v-slot:headerTitle>
                <h4 class="card-title"> {{ $t('social_service.follow_up') }} {{ $t('globalTrans.entry') }}</h4>
            </template>
            <!-- Body -->
            <template v-slot:body>
              <b-card style="border: 2px solid">
            <h4>{{ $t('hospital_information.patient_registration') }} {{ $t('globalTrans.search') }}</h4>
            <b-row>
                <b-col lg="9" sm="9">
                    <ValidationProvider name="Hospital Name" vid="hospital_id">
                      <b-form-group
                        class="row"
                        label-cols-sm="12"
                        label-for="hospital_id"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('hospital_configuration.hospital_name')}}
                        </template>
                        <v-select name="Bank"
                            v-model="searchx.hospital_id"
                            label="text"
                            :reduce="item => item.value"
                            :options= hospitalList
                            :placeholder="$t('globalTrans.select')"
                            :filter-by="myFilter"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                </b-col>
                <b-col xs="12" sm="12" md="7" lg="7" xl="3">
                    <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('hospital_information.form_no')"
                    label-for="auto_id"
                    >
                    <b-form-input
                        id="auto_id"
                        v-model="searchx.auto_id"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="7" lg="7" xl="3">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('hospital_information.patient_name')"
                    label-for="designation"
                    >
                    <b-form-input
                        id="designation"
                        v-model="searchx.patient_name"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="7" lg="7" xl="3">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('externalUser.nid')"
                    label-for="designation"
                    >
                    <b-form-input
                        id="designation"
                        v-model="searchx.nid"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                    <b-button type="button" variant="primary" @click="loadSearchData">{{ $t('globalTrans.search')}}</b-button>
                </b-col>
            </b-row>
            <br>
            <b-overlay :show="unitLoad">
              <table class="table table-bordered" v-if="patientData">
                <tr class="bg-light">
                  <th>{{$t('hospital_information.sl')}}</th>
                  <th>{{$t('hospital_information.sl')}}</th>
                  <th>{{$t('globalTrans.name')}}</th>
                  <th>{{$t('externalUser.nid')}}</th>
                  <th>{{$t('externalUser.brs_no')}}</th>
                  <th>{{$t('globalTrans.phone_no')}}</th>
                  <th>{{$t('hospital_information.form_no')}}</th>
                </tr>
                <tr v-for="(item, index) in patientData" :key="index" @click="dataCopy(item)">
                  <td><input type="radio" id="html" name="fav_language" value="HTML"></td>
                  <td>{{ $n(index + 1) }}</td>
                  <td>{{ $i18n.locale === 'bn' ? item.patient_name_bn : item.patient_name }}</td>
                  <td>{{ item.nid }}</td>
                  <td>{{ item.brs_no }}</td>
                  <td>{{ item.phone_no }}</td>
                  <td>{{ item.auto_id }}</td>
                </tr>
              </table>
               </b-overlay>
</b-card>
<hr>
                <!-- Form to Store -->
                <b-row>
                  <b-col xl="12" lg="12" sm="12">
                    <b-overlay :show="loadingPatient" rounded="sm">
                      <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                          <b-row>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Patient Type" vid="patient_type" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="patient_type"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('social_service.patient_type')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                    plain
                                    v-model="followup_mains.patient_type"
                                    :options="patientTypeList"
                                    id="patient_type"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="true"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4" hidden>
                              <ValidationProvider name="Form No" vid="form_no" :rules="`${followup_mains.patient_type === 1 ? 'required|max:100' : ''}`">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="form_no"
                                    slot-scope="{ valid, errors }"
                                >
                                  <template v-slot:label>
                                    {{$t('social_service.form_no')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-input
                                    class="form-control"
                                    v-model="followup_mains.form_no"
                                    id="form_no"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="true"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                      {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Follow Up No (EN)" vid="follow_up_no" rules="required|max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="follow_up_no"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.follow_up_no')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.follow_up_no"
                                      id="follow_up_no"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Follow Up Date" vid="follow_up_date" rules="required">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="follow_up_date"
                                    slot-scope="{ valid, errors }"
                                >
                                  <template v-slot:label>
                                    {{$t('social_service.follow_up_date')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-input
                                    class="form-control"
                                    v-model="followup_mains.follow_up_date"
                                    placeholder="Select Date"
                                    id="follow_up_date"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                      {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Help Description (BN)" vid="help_description_bn" rules="required|max:255">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="help_description_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.help_desc_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.help_description_bn"
                                      id="help_description_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Help Description (EN)" vid="help_description" rules="required|max:255">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="help_description"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.help_desc_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.help_description"
                                      id="help_description"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Helping Date" vid="helping_date" rules="required">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="helping_date"
                                    slot-scope="{ valid, errors }"
                                >
                                  <template v-slot:label>
                                    {{$t('social_service.helping_date')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-input
                                    class="form-control"
                                    v-model="followup_mains.helping_date"
                                    placeholder="Select Date"
                                    id="helping_date"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                      {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Support Authority (BN)" vid="support_authority_bn" rules="required|max:255">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="support_authority_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.supporting_authority_bn')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.support_authority_bn"
                                        id="support_authority_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Support Authority (EN)" vid="support_authority" rules="required|max:255">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="support_authority"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.supporting_authority_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.support_authority"
                                      id="support_authority"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Relation" vid="relation_bn" rules="required|max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="relation_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.relation_patient_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.relation_bn"
                                      id="relation_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Relation" vid="relation" rules="required|max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="relation"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.relation_patient_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.relation"
                                      id="relation"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="NID No" vid="nid_no" rules="required|max:255">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="nid_no"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.register_nid')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.nid_no"
                                        id="nid_no"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <!-- <b-col sm="12" lg="4" xl="4">
                              <h3>Data Divider</h3>
                            </b-col> -->

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Patient Name (BN)" vid="patient_name_bn" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="patient_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.patient_bn')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.patient_name_bn"
                                        id="patient_name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Patient Name (EN)" vid="patient_name" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="patient_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.patient_en')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.patient_name"
                                        id="patient_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Father Name (BN)" vid="father_name_bn" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="father_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.father_name_bn')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.father_name_bn"
                                        id="father_name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Father Name (EN)" vid="father_name" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="father_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.father_name_en')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.father_name"
                                        id="father_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Mother Name (BN)" vid="mother_name_bn" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="mother_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.mother_name_bn')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.mother_name_bn"
                                        id="mother_name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Mother Name (EN)" vid="mother_name" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="mother_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.mother_name_en')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.mother_name"
                                        id="mother_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Guardian Name (BN)" vid="guardian_name_bn" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="guardian_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.guardian_name_bn')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.guardian_name_bn"
                                        id="guardian_name_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Guardian Name (EN)" vid="guardian_name" rules="required|max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="guardian_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.guardian_name_en')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.guardian_name"
                                        id="guardian_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Mobile No" vid="phone_no" rules="required|numeric|max:20">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="phone_no"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.mobile_no')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="followup_mains.patient_reg_mains.phone_no"
                                        id="phone_no"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                          </b-row>

                          <!-- Adress -->
                          <b-row>
                            <b-col xl="12" lg="12" sm="12">
                              <iq-card>
                                  <div style="font-size:18px; background-color: #386389;">
                                      <h5 class="text-white text-center">
                                          {{ $t('social_service.patient_addres') }}
                                      </h5>
                                  </div>
                              </iq-card>
                            </b-col>
                          </b-row>

                          <b-row>
                            <!-- Area Type -->
                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Area Type" vid="area_type_id" rules="required|min_value:1">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="area_type_id"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('hospital_public_panel.area_type')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="followup_mains.patient_reg_mains.area_type_id"
                                    :options="areaTypeList"
                                    id="area_type_id"
                                    @change="getAreaTypeData(followup_mains.patient_reg_mains.area_type_id)"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- Division -->
                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Division" vid="division_id" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="4"
                                  label-for="division_id"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('hospital_public_panel.division')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="followup_mains.patient_reg_mains.division_id"
                                  :options="divisionList"
                                  id="division_id"
                                  @change="changeDivisionId(followup_mains.patient_reg_mains.division_id)"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- District -->
                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="District" vid="district_id" rules="required|min_value:1">
                                <b-form-group
                                  class="row"
                                  label-cols-sm="4"
                                  label-for="district_id"
                                  slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{$t('hospital_public_panel.district')}} <span class="text-danger">*</span>
                                </template>
                                <b-form-select
                                  plain
                                  v-model="followup_mains.patient_reg_mains.district_id"
                                  :options="districtList"
                                  id="district_id"
                                  @change="changeDistrictId(followup_mains.patient_reg_mains.district_id)"
                                  :state="errors[0] ? false : (valid ? true : null)"
                                  :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                >
                                <template v-slot:first>
                                  <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- City Corporation -->
                            <b-col sm="12" lg="4" xl="4" v-show="cityCorporationShow">
                              <ValidationProvider name="City Corporation" vid="city_corporation_id" :rules="`${cityCorporationShow ? 'required|min_value:1' : ''}`">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="city_corporation_id"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('hospital_public_panel.city_corporation')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="followup_mains.patient_reg_mains.city_corporation_id"
                                    :options="cityCorporationList"
                                    id="city_corporation_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- Upazila -->
                            <b-col sm="12" lg="4" xl="4" v-show="upazilaShow">
                              <ValidationProvider name="Upazila" vid="upazilla_id" :rules="`${upazilaShow ? 'required|min_value:1' : ''}`">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="upazilla_id"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('hospital_public_panel.upazila')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="followup_mains.patient_reg_mains.upazilla_id"
                                    :options="upazilaList"
                                    id="upazilla_id"
                                    @change="changeUpazillaId(followup_mains.patient_reg_mains.upazilla_id)"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- Union -->
                            <b-col sm="12" lg="4" xl="4" v-show="unionShow">
                              <!-- <ValidationProvider name="Union" vid="union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`"> -->
                              <ValidationProvider name="Union" vid="union_id" rules="">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="union_id"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('hospital_public_panel.union')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="followup_mains.patient_reg_mains.union_id"
                                    :options="unionList"
                                    id="union_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- Pourashava -->
                            <b-col xl="4" lg="4" sm="12" v-show="pourashavaShow">
                              <!-- <ValidationProvider name="Pourashava" vid="pauroshoba_id" :rules="`${pourashavaShow ? 'required|min_value:1' : ''}`"> -->
                              <ValidationProvider name="Pourashava" vid="pauroshoba_id" rules="">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="pauroshoba_id"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{$t('hospital_public_panel.pourashava')}} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="followup_mains.patient_reg_mains.pauroshoba_id"
                                    :options="pauroshobaList"
                                    id="pauroshoba_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- Ward -->
                            <b-col xl="4" lg="4" sm="12" v-show="wardShow">
                              <!-- <ValidationProvider name="Ward" vid="ward_id" :rules="`${wardShow ? 'required|min_value:1' : ''}`"> -->
                              <ValidationProvider name="Ward" vid="ward_id" rules="">
                                  <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="ward_id"
                                    slot-scope="{ valid, errors }"
                                  >
                                  <template v-slot:label>
                                    {{ $t('org_pro.ward') }} <span class="text-danger">*</span>
                                  </template>
                                  <b-form-select
                                    plain
                                    v-model="followup_mains.patient_reg_mains.ward_id"
                                    :options="wardList"
                                    id="ward_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    :disabled="followup_mains.patient_reg_mains.id !== 0 ? true : false"
                                  >
                                  <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                  </template>
                                  </b-form-select>
                                  <div class="invalid-feedback">
                                    {{ errors[0] }}
                                  </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <!-- Hospital Name -->
                            <b-col xl="4" lg="4" sm="12">
                                    <ValidationProvider name="Hospital Name" vid="hospital_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="hospital_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{$t('social_service.hospital_name')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-select
                                            plain
                                            disabled
                                            v-model="followup_mains.hospital_id"
                                            :options="hospitalList"
                                            id="hospital_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                          </b-row>

                          <!-- Action Taken and Patient Improvement or Current Situation | Title -->
                          <b-row>
                            <b-col xl="12" lg="12" sm="12">
                              <iq-card>
                                  <div style="font-size:18px; background-color: #386389;">
                                      <h5 class="text-white text-center">
                                          {{ $t('social_service.ac_tk_p_impr_c_s') }}
                                      </h5>
                                  </div>
                              </iq-card>
                            </b-col>
                          </b-row>

                          <!-- For in loop | row | followup_action -->
                          <b-row v-for="(action,index) in followup_mains.followup_actions" :key=index>

                            <b-col sm="12" lg="6" xl="6">
                              <ValidationProvider name="Action" :vid="'action_bn_' + index" rules="required|max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      :label-for="'action_bn_' + index"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.action_taken_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="action.action_bn"
                                      :id="'action_bn_' + index"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                             <b-col sm="12" lg="6" xl="6">
                              <ValidationProvider name="Action" :vid="'action_' + index" rules="required|max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      :label-for="'action_' + index"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.action_taken_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="action.action"
                                      :id="'action_' + index"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="6" xl="6">
                              <ValidationProvider name="Action" :vid="'follow_progress_bn_' + index" rules="required|max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      :label-for="'follow_progress_bn_' + index"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.follow_prograss_situation_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-textarea
                                      class="form-control"
                                      v-model="action.follow_progress_bn"
                                      :id="'follow_progress_bn_' + index"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                      rows="3"
                                      max-rows="5"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="6" xl="6">
                              <ValidationProvider name="Action" :vid="'follow_progress_' + index" rules="required|max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      :label-for="'follow_progress_' + index"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.follow_prograss_situation_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-textarea
                                      class="form-control"
                                      v-model="action.follow_progress"
                                      :id="'follow_progress_' + index"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                      rows="3"
                                      max-rows="5"
                                    ></b-form-textarea>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <!-- Add & Remove Buttons -->
                            <b-col sm="6" lg="6" xl="6">
                              <div>
                                  <b-button type="button" v-show="index === (followup_mains.followup_actions.length - 1)" variant=" iq-bg-success" size="sm" @click="addActions">
                                    <i class="ri-add-line mr-1"></i>
                                  </b-button>
                                  <b-button type="button" v-show="index >= 0 && (followup_mains.followup_actions.length > 1)" variant=" iq-bg-danger" size="sm" @click="removeActions(index)">
                                    <i class="ri-delete-bin-line m-0"></i>
                                  </b-button>
                              </div>
                              <br>
                            </b-col>
                          </b-row>

                          <!-- Other Information | Title -->
                          <b-row>
                            <b-col xl="12" lg="12" sm="12">
                              <iq-card>
                                  <div style="font-size:18px; background-color: #386389;">
                                      <h5 class="text-white text-center">
                                          {{ $t('social_service.other_information') }}
                                      </h5>
                                  </div>
                              </iq-card>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Other Info (BN)" vid="other_info_bn" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="other_info_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.other_relavant_bn')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.other_info_bn"
                                      id="other_info_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Other Info (EN)" vid="other_info" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="other_info"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.other_relavant_en')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.other_info"
                                      id="other_info"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Patient Comment (BN)" vid="patient_comment_bn" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="patient_comment_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.comment_patient_bn')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.patient_comment_bn"
                                      id="patient_comment_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Patient Comment (EN)" vid="patient_comment" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="patient_comment"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.comment_patient_en')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.patient_comment"
                                      id="patient_comment"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Guardian Comment (BN)" vid="guardian_comment_bn" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="guardian_comment_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.comment_guardian_bn')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.guardian_comment_bn"
                                      id="guardian_comment_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Guardian Comment (EN)" vid="guardian_comment" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="guardian_comment"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.comment_guardian_en')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.guardian_comment"
                                      id="guardian_comment"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Social Officer Comment (BN)" vid="social_officer_comment_bn" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="social_officer_comment_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.comment_welfare_bn')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.social_officer_comment_bn"
                                      id="social_officer_comment_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Social Officer Comment (EN)" vid="social_officer_comment" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="social_officer_comment"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.comment_welfare_en')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.social_officer_comment"
                                      id="social_officer_comment"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Recommendation (BN)" vid="recommendation_bn" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="recommendation_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.recomnd_patient_bn')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.recommendation_bn"
                                      id="recommendation_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Recommendation (EN)" vid="recommendation" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="recommendation"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.recomnd_patient_en')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.recommendation"
                                      id="recommendation"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Next Action" vid="next_action" rules="max:100">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="next_action"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('social_service.follow_ups')}}
                                        </template>
                                        <div>
                                            <b-form-radio
                                                v-model="followup_mains.follow_up_check"
                                                name="followupOption"
                                                value="1"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >{{$t('social_service.if_follow')}}</b-form-radio>

                                            <b-form-radio
                                                v-model="followup_mains.follow_up_check"
                                                name="followupOption"
                                                value="2"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                            >{{$t('social_service.not_follow')}}</b-form-radio>
                                        </div>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Case Closing Date" vid="case_closing_date" rules="">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="case_closing_date"
                                    slot-scope="{ valid, errors }"
                                >
                                  <template v-slot:label>
                                    <div v-if="followup_mains.follow_up_check == 1">
                                    {{$t('social_service.if_follow')}} <span class="text-danger">*</span>
                                    </div>
                                    <div v-else-if="followup_mains.follow_up_check == 2">
                                    {{$t('social_service.not_follow')}} <span class="text-danger">*</span>
                                    </div>
                                    <div v-else>
                                    {{$t('social_service.case_close_date')}} <span class="text-danger">*</span>
                                    </div>
                                  </template>
                                  <b-form-input
                                    class="form-control"
                                    v-model="followup_mains.followup_others.case_closing_date"
                                    placeholder="Select Date"
                                    id="case_closing_date"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                  ></b-form-input>
                                  <div class="invalid-feedback">
                                      {{ errors[0] }}
                                  </div>
                                </b-form-group>
                              </ValidationProvider>
                            </b-col>

                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Follower Social Office Name (Bn)" vid="follower_off_name_bn" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="follower_off_name_bn"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.follow_ofc_name_bn')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.follower_off_name_bn"
                                      id="follower_off_name_bn"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                            <b-col sm="12" lg="4" xl="4">
                              <ValidationProvider name="Follower Social Office Name (En)" vid="follower_off_name" rules="max:100">
                                  <b-form-group
                                      class="row"
                                      label-cols-sm="12"
                                      label-for="follower_off_name"
                                      slot-scope="{ valid, errors }"
                                  >
                                    <template v-slot:label>
                                      {{$t('social_service.follow_ofc_name_en')}}
                                    </template>
                                    <b-form-input
                                      class="form-control"
                                      v-model="followup_mains.followup_others.follower_off_name"
                                      id="follower_off_name"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                              </ValidationProvider>
                            </b-col>
                          </b-row>

                          <!-- Relevent Document Upload | Title -->
                          <b-row>
                            <b-col xl="12" lg="12" sm="12">
                              <iq-card>
                                  <div style="font-size:18px; background-color: #386389;">
                                      <h5 class="text-white text-center">
                                          {{ $t('social_service.relevant_document_upload') }}
                                      </h5>
                                  </div>
                              </iq-card>
                            </b-col>
                          </b-row>

                          <b-overlay :show="customAttachment.loader" rounded="sm">
                            <b-row>
                              <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Document Title (Bn)" vid="document_title_bn" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="document_title_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.document_title_bn')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="customAttachment.document_title_bn"
                                        id="document_title_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                              </b-col>
                              <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Document Title" vid="document_title" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="document_title"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.document_title_en')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-input
                                        class="form-control"
                                        v-model="customAttachment.document_title"
                                        id="document_title"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                      ></b-form-input>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                              </b-col>

                              <b-col sm="12" lg="4" xl="4">
                                <ValidationProvider name="Attachment" vid="attachment" rules="">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="12"
                                        label-for="attachment"
                                        slot-scope="{ valid, errors }"
                                    >
                                      <template v-slot:label>
                                        {{$t('social_service.attachment')}} <span class="text-danger">*</span>
                                      </template>
                                      <b-form-file
                                        id="attachment"
                                        accept=".png, .jpg, .jpeg, .svg, .pdf, .doc, .docx, .tex, .txt, .rtf"
                                        class="form-control"
                                        v-model="customAttachment.attachment"
                                        v-on:change="onFileChange"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        :disabled="followup_mains.followup_docs.length >= 10"
                                      ></b-form-file>
                                      <div class="invalid-feedback">
                                          {{ errors[0] }}
                                      </div>
                                    </b-form-group>
                                </ValidationProvider>
                              </b-col>
                            </b-row>

                            <template v-if="followup_mains.followup_docs.length > 0">
                            <b-row>
                              <b-col xl="12" lg="12" sm="12">
                                <iq-card>
                                    <div style="font-size:18px; background-color: #386389;">
                                        <h5 class="text-white text-center">
                                            {{ $t('social_service.docu') }}
                                        </h5>
                                    </div>
                                </iq-card>
                             </b-col>
                            </b-row>
                              <template v-for="(attachedFile, index) in followup_mains.followup_docs">
                                  <b-row :key="index">
                                      <b-col cols="3">
                                          <span style="color: #609513">
                                            {{ attachedFile.document_title }}
                                          </span>
                                      </b-col>
                                      <b-col cols="3">
                                          <span style="color: #609513">
                                            {{ attachedFile.document_title_bn}}
                                          </span>
                                      </b-col>
                                      <b-col cols="4">
                                        <!-- Different Download Link | From Temp -->
                                        <a :href="hospitalServiceBaseUrl + 'download-attachment?file=' + attachedFile.file_name" target="_blank" v-if="attachedFile.id === 0">
                                            {{ attachedFile.original_file_name }}
                                            <i class="ri-download-cloud-line" ></i>
                                        </a>

                                        <!-- Different Download Link | From Storage -->
                                        <a :href="hospitalServiceBaseUrl + 'download-attachment?file=' + attachedFile.attachment" target="_blank" v-if="attachedFile.id > 0">
                                          {{ attachedFile.attachment.split('/').pop() }}
                                          <i class="ri-download-cloud-line" ></i>
                                        </a>
                                      </b-col>
                                      <b-col cols="2">
                                        <!-- Different Delete | One deletes File from Temp -->
                                        <b-button variant=" iq-bg-danger" size="sm" v-if="attachedFile.id === 0" @click="deleteUploadedFile(attachedFile.file_name)">
                                          <i class="ri-delete-bin-line m-0"> </i>
                                        </b-button>

                                        <!-- Different Delete | Deletes DB Record & File -->
                                        <b-button variant=" iq-bg-danger" size="sm" v-if="attachedFile.id > 0" @click="deleteUploadedFileFromDatabase(attachedFile)">
                                          <i class="ri-delete-bin-line m-0"> </i>
                                        </b-button>
                                      </b-col>
                                  </b-row>
                                  <br :key="index + 999"/>
                                </template>
                            </template>
                          </b-overlay>
                          <b-row>
                            <div class="col text-left">
                                <b-button  style="background-color: rgb(0, 91, 91); border-color: rgb(0, 91, 91)">
                                  <router-link style="color:white" :to="{ path: '/hospital-disability-service/social-service/followup'}">Back</router-link>
                                </b-button>
                            </div>
                            <div class="col-sm-3"></div>
                            <div class="col text-right">
                              <b-button type="submit" id="button-5" variant="primary" class="mr-2">{{ $t('globalTrans.save') }}</b-button>
                            </div>
                          </b-row>
                        </b-form>
                      </ValidationObserver>
                    </b-overlay>
                  </b-col>
                </b-row>

            </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Custom from '../../../../../../store/custom'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { patientSearchList, followUpStoreApi, assignUserHospitalApi, followUpUpdateApi, followUpUploadFileApi, followUpDeleteFileApi, followUpDeleteDocApi } from '../../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['id', 'item'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      searchx: {
          nid: '',
          hospital_id: '',
          auto_id: '',
          from_date: '',
          to_date: '',
          patient_name: ''

      },
      follow_up_check: 0,
      hospitalServiceBaseUrl: hospitalServiceBaseUrl,
      blockForm: true,
      //
      loadingPatient: false,
      isSearchInValid: false,
      // Area Type Related Data
      cityCorporationShow: false,
      upazilaShow: false,
      unionShow: false,
      pourashavaShow: false,
      wardShow: false,
      districtList: [],
      cityCorporationList: [],
      upazilaList: [],
      pauroshobaList: [],
      unionList: [],
      // Patient Type Search Form Data
      // patientTypeForm: {
      //   patient_type: 0,
      //   form_no: ''
      // },
      // Handling (Add More) File Upload
      customAttachment: {
        document_title: null,
        document_title_bn: null,
        attachment: [],
        loader: false
      },
      /**
       * Main Data
       */
      followup_mains: {
        follow_up_check: 0,
        office_id: '',
        hospital_id: '',
        follow_up_no: '',
        patient_type: 1,
        form_no: '', // If Patient type is “Registered"
        follow_up_date: '',
        help_description: '',
        help_description_bn: '',
        helping_date: '',
        support_authority: '',
        support_authority_bn: '',
        nid_no: '',
        relation: '',
        relation_bn: '',
        followup_actions: [
          { action: '', action_bn: '', follow_progress: '', follow_progress_bn: '' }
        ],
        followup_docs: [
          // { id: 0, original_file_name: 'Testing-Code', file_name: 'Testing-Code', document_title: 'Testing-Code', document_title_bn: 'Testing-Code' }
        ],
        /** Nested Inside is followup_others & patient_reg_mains */
        followup_others: {
          other_info: '',
          other_info_bn: '',
          patient_comment: '',
          patient_comment_bn: '',
          guardian_comment: '',
          guardian_comment_bn: '',
          social_officer_comment: '',
          social_officer_comment_bn: '',
          recommendation: '',
          recommendation_bn: '',
          case_closing_date: '',
          follower_off_name: '',
          follower_off_name_bn: ''
        },
        patient_reg_mains: {
          id: 0,
          patient_name: '',
          patient_name_bn: '',
          phone_no: '',
          father_name: '',
          father_name_bn: '',
          mother_name: '',
          mother_name_bn: '',
          guardian_name: '',
          guardian_name_bn: '',
          area_type_id: 0,
          division_id: 0,
          district_id: 0,
          city_corporation_id: 0,
          upazilla_id: 0,
          union_id: 0,
          pauroshoba_id: 0,
          ward_id: 0
        }
      },
      hospitalIds: [],
      patientData: [],
      hospitalList: [],
      unitLoad: false
    }
  },
  created () {
    this.hospitalList = this.getHospitalListAll()
    if (this.$route.query.id) {
      const tmp = this.getFollowupData()
      if (tmp) {
        this.followup_mains = tmp
        this.fillForm(this.followup_mains.patient_reg_mains.area_type_id)
      } else {
        this.$router.push({ path: '/hospital-disability-service/social-service/followup' })
      }
    }
    var officeId = this.$store.state.Auth.authUser.office_id
      if (officeId > 1) {
          this.userId = this.$store.state.Auth.authUser.user_id
          if (this.userId > 1) {
              this.getUserWiseHospital(this.userId)
          }
      } else {
          this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
              this.hospitalIds.push(obj.value)
          })
      }
      if (this.$store.state.Auth.activeRoleId !== 1) {
        this.userId = this.$store.state.Auth.authUser.user_id
        if (this.$store.state.Auth.authUser.is_org_admin !== 1) {
          this.getUserWiseHospital(this.userId)
        }
      }
  },
  mounted () {
    flatpickr('#follow_up_date', {})
    flatpickr('#helping_date', {})
    flatpickr('#case_closing_date', {})
  },
  computed: {
    areaTypeList () {
      const objectData = Custom.wardTypeList
      return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.id, text: obj.name_bn }
          } else {
              return { value: obj.id, text: obj.name }
          }
      })
    },
    divisionList () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    wardList () {
      /**
       * Ward List is sparse, therefore loading all data instead of filtering
       */
      const objectData = this.$store.state.commonObj.wardList
      return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
      })
    },
    patientTypeList () {
      return this.$store.state.HospitalDisabilityService.commonObj.patientTypeList.filter(item => item.value === 1)
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
      // 'patientTypeForm.patient_type': function (newVal, oldVal) {
      //   this.isSearchInValid = false
      //   this.patientTypeForm.form_no = ''
      //   this.followup_mains.patient_type = newVal
      //   this.followup_mains.form_no = ''
      //   this.resetPatientRegMains()
      //   this.getAreaTypeData(0)
      // }
      'searchx.hospital_id': function (newVal, oldVal) {
        this.followup_mains.hospital_id = this.searchx.hospital_id
      }
  },
  methods: {
    async getUserWiseHospital (userId) {
      const params = Object.assign({ user_id: userId })
      const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
      if (result.success) {
              this.hospitalIds = result.data
      } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
      }
      // this.loadData()
      this.hospitalList = this.getHospitalListAll()
      if (this.hospitalList.length) {
        this.searchx.hospital_id = this.hospitalList[0].value
      }
    },
    getHospitalListAll: function () {
      let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
      if (this.hospitalIds.length > 0) {
        hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
      }
      return hospitalList
    },
    /**
     * Methods for (Add More) File Upload
     */
     dataCopy (item) {
        this.followup_mains.patient_reg_mains = item
        // this.followup_mains.case_history_no = 0
        // this.search.auto_id = item.auto_id
        // this.search.patient_type_id = 1
        // this.followup_mains.patient_type_id = 1
        // this.followup_mains.id_type = item.nid_or_brs
        // this.followup_mains.occupation_id = item.occupation_id
        this.followup_mains.hospital_id = item.hospital_id
        this.followup_mains.form_no = item.form_no
        this.followup_mains.auto_id = item.auto_id
        this.followup_mains.nid_no = item.nid > 0 ? item.nid : item.brs_no
        this.fillForm(this.followup_mains.patient_reg_mains.area_type_id)
    },
    myFilter: (option, text, search) => {
        const temp = search.toLowerCase()
        return option.text_en.toLowerCase().indexOf(temp) > -1 ||
        option.text_bn.toLowerCase().indexOf(temp) > -1
    },
     loadSearchData () {
        this.unitLoad = true
        const params = Object.assign({}, this.searchx)
        RestApi.getData(hospitalServiceBaseUrl, patientSearchList, params).then(response => {
            if (response.success) {
              this.patientData = response.data
              this.unitLoad = false
            } else {
              this.unitLoad = false
            }
        })
    },
    async onFileChange (e) {
      if (!this.validateFileUploadAssciatedFields()) {
        return
      }
      this.customAttachment.loader = true
      const config = {
          headers: { 'content-type': 'multipart/form-data' }
      }
      var formData = new FormData()
      formData.append('custom_file', e.target.files[0])

      const result = await RestApi.postData(hospitalServiceBaseUrl, followUpUploadFileApi, formData, config)
      if (result.success) {
          this.followup_mains.followup_docs.push({
            id: 0, // id - 0 signifies that file is uploaded but DB Record is not created yet
            original_file_name: result.data.originalFileName,
            file_name: result.data.fileFullPath,
            document_title: this.customAttachment.document_title,
            document_title_bn: this.customAttachment.document_title_bn
          })
          this.customAttachment = Object.assign({}, {
            document_title: null,
            document_title_bn: null,
            attachment: [],
            loader: false
          })
      } else {
        // From Back End get error in custom_file & assign to attachemnt on the frontend
        const errors = { attachment: [result.errors.custom_file] }
        this.$refs.form.setErrors(errors)
      }
    },
    validateFileUploadAssciatedFields () {
        let errors = {}
        if (this.customAttachment.document_title === null || this.customAttachment.document_title === '') {
            errors = Object.assign({}, errors, { document_title: ['Document Tile field is required'] })
        }
        if (this.customAttachment.document_title_bn === null || this.customAttachment.document_title_bn === '') {
            errors = Object.assign({}, errors, { document_title_bn: ['Document Tile (Bn) field is required'] })
        }
        if (Object.keys(errors).length > 0) {
            this.$refs.form.setErrors(errors)
            this.customAttachment.attachment = []
            return false
        }
        return true
    },
    validateFileUploadArrayLength () {
      // Validating length of array when form is submitted, ensuring at least on attachment is uploaded.
      if (this.followup_mains.followup_docs.length <= 0) {
        const errors = {
          document_title: ['Document Tile field is required'],
          document_title_bn: ['Document Tile (Bn) field is required'],
          attachment: ['An Attachment is required']
        }
        this.$refs.form.setErrors(errors)
        return false
      }
      return true
    },
    async deleteUploadedFile (fileName) {
        this.customAttachment.loader = true
        const result = await RestApi.deleteData(hospitalServiceBaseUrl, followUpDeleteFileApi, { file_name: fileName })
        this.customAttachment.loader = false
        if (!result.success) {
            this.$toast.error({
                title: 'Error',
                message: 'Failed to delete file. Please, try again.'
            })
            return
        }
        const tmp = this.followup_mains.followup_docs.filter(item => {
            return item.file_name !== fileName
        })
        this.followup_mains.followup_docs = tmp
    },
    async deleteUploadedFileFromDatabase (file) {
      this.customAttachment.loader = true
      const result = await RestApi.deleteData(hospitalServiceBaseUrl, `${followUpDeleteDocApi}/${file.id}`)
      this.customAttachment.loader = false
      if (!result.success) {
          this.$toast.error({
              title: 'Error',
              message: 'Failed to delete file. Please, try again.'
          })
          return
      }
      const tmp = this.followup_mains.followup_docs.filter(item => {
          return item.id !== file.id
      })
      this.followup_mains.followup_docs = tmp
    },
    getAreaTypeData (typeId) {
      /**
       * 1 - City Corporation (City-Coporation, Ward)
       * 2 - Pauroshoba (Upazila, Pourosoba, Ward)
       * 3 - Union (Upazila, Pourosoba, Ward)
       */
      if (typeId === 1) {
        /** City Corporation */
        this.followup_mains.patient_reg_mains.city_corporation_id = 0
        this.followup_mains.patient_reg_mains.upazilla_id = 0
        this.followup_mains.patient_reg_mains.pauroshoba_id = 0
        this.followup_mains.patient_reg_mains.union_id = 0
        this.followup_mains.patient_reg_mains.ward_id = 0
        this.cityCorporationShow = true
        this.upazilaShow = false
        this.pourashavaShow = false
        this.unionShow = false
        this.wardShow = true
      } else if (typeId === 2) {
        /** Pauroshoba */
        this.followup_mains.patient_reg_mains.city_corporation_id = 0
        this.followup_mains.patient_reg_mains.upazilla_id = 0
        this.followup_mains.patient_reg_mains.pauroshoba_id = 0
        this.followup_mains.patient_reg_mains.union_id = 0
        this.followup_mains.patient_reg_mains.ward_id = 0
        this.cityCorporationShow = false
        this.upazilaShow = true
        this.pourashavaShow = true
        this.unionShow = false
        this.wardShow = true
      } else if (typeId === 3) {
        /** Union */
        this.followup_mains.patient_reg_mains.city_corporation_id = 0
        this.followup_mains.patient_reg_mains.upazilla_id = 0
        this.followup_mains.patient_reg_mains.pauroshoba_id = 0
        this.followup_mains.patient_reg_mains.union_id = 0
        this.followup_mains.patient_reg_mains.ward_id = 0
        this.cityCorporationShow = false
        this.upazilaShow = true
        this.pourashavaShow = false
        this.unionShow = true
        this.wardShow = true
      } else {
        // Resetting The Form & Data
        this.followup_mains.patient_reg_mains.city_corporation_id = 0
        this.followup_mains.patient_reg_mains.upazilla_id = 0
        this.followup_mains.patient_reg_mains.pauroshoba_id = 0
        this.followup_mains.patient_reg_mains.union_id = 0
        this.followup_mains.patient_reg_mains.ward_id = 0
        this.cityCorporationShow = false
        this.upazilaShow = false
        this.pourashavaShow = false
        this.unionShow = false
        this.wardShow = false
      }
      /** Upadting cityCorporationList & upazilaList */
      this.cityCorporationList = this.getCityCorporationList(this.followup_mains.patient_reg_mains.district_id)
      this.upazilaList = this.getUpazilaList(this.followup_mains.patient_reg_mains.district_id)
    },
    getDistrictList (divisionId = null) {
      return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === divisionId)
    },
    getCityCorporationList (districtId = null) {
      return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getUpazilaList (districtId = null) {
      return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === districtId)
    },
    getUnionList (upazillaId = null) {
      return this.$store.state.commonObj.unionList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
    },
    getPauroshobaList (upazillaId = null) {
      return this.$store.state.commonObj.pauroshobaList.filter(item => item.status === 0 && item.upazilla_id === upazillaId)
    },
    addActions () {
      this.followup_mains.followup_actions.push({ action: '', action_bn: '', follow_progress: '', follow_progress_bn: '' })
    },
    removeActions (index) {
      this.followup_mains.followup_actions.splice(index, 1)
    },
    /**
     * @ change methods
     */
    changeDivisionId (divisionId) {
      this.followup_mains.patient_reg_mains.district_id = 0
      this.districtList = this.getDistrictList(divisionId)
    },
    changeDistrictId (districtId) {
      this.followup_mains.patient_reg_mains.city_corporation_id = 0
      this.followup_mains.patient_reg_mains.upazilla_id = 0
      this.cityCorporationList = this.getCityCorporationList(districtId)
      this.upazilaList = this.getUpazilaList(districtId)
      this.hospitalList = this.getHospitalListByDistrictId(districtId)
    },
    getHospitalListByDistrictId (districtId = null) {
       return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.district_id === districtId)
    },
    // getHospitalListAll: function () {
    //   return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
    // },
    changeUpazillaId (upazillaId) {
      this.followup_mains.patient_reg_mains.pauroshoba_id = 0
      this.followup_mains.patient_reg_mains.union_id = 0
      this.pauroshobaList = this.getPauroshobaList(upazillaId)
      this.unionList = this.getUnionList(upazillaId)
    },
    // (ward-change) city_corporation_id, pauroshoba_id, union_id
    /** Fill Form */
    fillForm (typeId) {
      this.districtList = this.getDistrictList(this.followup_mains.patient_reg_mains.division_id)
      if (typeId === 1) {
        /** City Corporation */
        this.cityCorporationList = this.getCityCorporationList(this.followup_mains.patient_reg_mains.district_id)
        this.cityCorporationShow = true
        this.upazilaShow = false
        this.pourashavaShow = false
        this.unionShow = false
        this.wardShow = true
      } else if (typeId === 2) {
        /** Pauroshoba */
        this.upazilaList = this.getUpazilaList(this.followup_mains.patient_reg_mains.district_id)
        this.pauroshobaList = this.getPauroshobaList(this.followup_mains.patient_reg_mains.upazilla_id)
        this.cityCorporationShow = false
        this.upazilaShow = true
        this.pourashavaShow = true
        this.unionShow = false
        this.wardShow = true
      } else if (typeId === 3) {
        /** Union */
        this.upazilaList = this.getUpazilaList(this.followup_mains.patient_reg_mains.district_id)
        this.unionList = this.getUnionList(this.followup_mains.patient_reg_mains.upazilla_id)
        this.cityCorporationShow = false
        this.upazilaShow = true
        this.pourashavaShow = false
        this.unionShow = true
        this.wardShow = true
      }
    },
    resetPatientRegMains () {
      this.followup_mains.patient_reg_mains.id = 0
      this.followup_mains.patient_reg_mains.patient_name = ''
      this.followup_mains.patient_reg_mains.patient_name_bn = ''
      this.followup_mains.patient_reg_mains.phone_no = ''
      this.followup_mains.patient_reg_mains.father_name = ''
      this.followup_mains.patient_reg_mains.father_name_bn = ''
      this.followup_mains.patient_reg_mains.mother_name = ''
      this.followup_mains.patient_reg_mains.mother_name_bn = ''
      this.followup_mains.patient_reg_mains.guardian_name = ''
      this.followup_mains.patient_reg_mains.guardian_name_bn = ''
      this.followup_mains.patient_reg_mains.area_type_id = 0
      this.followup_mains.patient_reg_mains.division_id = 0
      this.followup_mains.patient_reg_mains.district_id = 0
      this.followup_mains.patient_reg_mains.city_corporation_id = 0
      this.followup_mains.patient_reg_mains.upazilla_id = 0
      this.followup_mains.patient_reg_mains.union_id = 0
      this.followup_mains.patient_reg_mains.pauroshoba_id = 0
      this.followup_mains.patient_reg_mains.ward_id = 0
    },
    /**
     * patientTypeForm `@submit`
     */
            // async handlePatientTypeForm () {
            //   const params = {
            //     patient_type: this.patientTypeForm.patient_type,
            //     auto_id: this.patientTypeForm.auto_id
            //   }
            //   this.loadingPatient = true
            //   const result = await RestApi.getData(hospitalServiceBaseUrl, followUpGetPatientAutoId, params)
            //   if (result.success) {
            //     this.followup_mains.form_no = result.data.form_no
            //     this.followup_mains.auto_id = result.data.auto_id
            //     this.isSearchInValid = false
            //     this.followup_mains.patient_reg_mains = result.data
            //     this.fillForm(this.followup_mains.patient_reg_mains.area_type_id)
            //   } else if (!result.success) {
            //     this.followup_mains.form_no = ''
            //     this.isSearchInValid = true
            //     this.resetPatientRegMains()
            //     this.getAreaTypeData(0)
            //   }
            //   this.loadingPatient = false
            // },
    /**
     * Filling 5 Fields with Random Data for Now
     * `hos_followup_mains`
     * office_id, hospital_id
     *
     * `in_patient_reg_mains`
     * hospital_id, reg_date, gender_id,
     *
     */
    fillerData () {
      this.followup_mains.office_id = 7
      this.followup_mains.patient_reg_mains.hospital_id = 7
      this.followup_mains.patient_reg_mains.reg_date = this.followup_mains.follow_up_date
      this.followup_mains.patient_reg_mains.gender_id = 1
    },
    /**
     * Now getData from $store &
     * Save Method
     */
    getFollowupData () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.$route.query.id))
      return tmpData ? JSON.parse(JSON.stringify(tmpData)) : null
    },
    async saveData () {
      if (!this.validateFileUploadArrayLength()) return

      this.fillerData()
      this.loadingPatient = true
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null

      const loadingState = { loading: false, listReload: true }

      if (this.$route.query.id) {
        result = await RestApi.putData(hospitalServiceBaseUrl, `${followUpUpdateApi}/${this.$route.query.id}`, this.followup_mains)
      } else {
        result = await RestApi.postData(hospitalServiceBaseUrl, followUpStoreApi, this.followup_mains)
      }

      this.loadingPatient = false
      this.$store.dispatch('mutateCommonProperties', loadingState)

      if (result.success) {
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })

        this.$router.push({ path: '/hospital-disability-service/social-service/followup' })
      } else {
        this.$refs.form.setErrors(result.errors)
      }
      // END
    }
  }
}
</script>
